import {
  AUDITS_DATA,
  AUDITS_START,
  AUDITS_END,
} from "../../slices/type";

interface InitState {
  data: any[];
  dataSingle: any[];
  loading: boolean;
}

const initState: InitState = {
  data: [],
  dataSingle: [],
  loading: false,
};

interface Action {
  type: string;
  payload?: any;
  loading?: boolean;
}

const Audit_Red = (state = initState, action: Action): InitState => {
  switch (action.type) {
    case AUDITS_START:
      return {
        ...state,
        loading: action.loading ?? false,
      };
    case AUDITS_DATA:
      return {
        ...state,
        data: action.payload ?? [],
        loading: action.loading ?? false,
      };
 
    case AUDITS_END:
      return {
        ...state,
        dataSingle: action.payload ?? [],
        loading: action.loading ?? false,
      };
    default:
      return state;
  }
};

export default Audit_Red;
